import axios from 'axios'
import { APIEndPoints } from './APIEndPoints'
import { getType } from './bulkOnboardingFileDownload'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const bulkOnboardingFileUpload: any = (file: File, type: string, tokens: any) => {
  const reqBody = new FormData()
  reqBody.append('file', file)
  reqBody.append('type', getType(type))
  const config = {
    headers: {
      ...sitConfig(tokens).headers,
      'Content-Type': 'multipart/form-data',
      formData: true,
      parseReqBody: true,
    },
  }
  return axios.post(`${APIEndPoints.bulkOnboardUpload}`, reqBody, config).then((response) => {
    return responseParser(response)
  })
}

export { bulkOnboardingFileUpload }
